import { combineReducers } from "redux";
import authReducer from "./Auth";
import userReducer from "./user";
import headOfficeAdvice from "./advice";
import branchAdvice from "./branchAdvice";
import location from "./location";
import newAdvice from "./newAdvice";
import allAdviceData from "./allAdviceData";
import specificBranchAdvice from "./specificBranchAdvice";
import receivingBranch from "./receivingBranch";
import unapprovedAdvice from "./unapprovedAdvice";
export default combineReducers({
  auth: authReducer,
  users: userReducer,
  headOfficeAdvice,
  branchAdvice,
  location,
  message: newAdvice,
  allAdviceData,
  specificBranchAdvice,
  receivingBranch,
  unapprovedAdvice,
});
